export enum NotificationKeys {
    AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
    PASSWORD_RECOVERY_EMAIL_SUCCESSFULLY_SENT = 'PASSWORD_RECOVERY_EMAIL_SUCCESSFULLY_SENT',
    RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS',
}
